import { Component, Host, State, h } from '@stencil/core';
import { Unsubscribe, store } from '@stencil/redux';
import { AltFlowType } from '../../class/class';
import { Language } from '../../enums/const-enums';
import { RootState, initialStore } from '../../redux/store';
import { SignCancel } from '../../service/sign-cancel';
import { handleContinueResponse, logd } from '../../utils/utils';
import {
  RassChangeAccountTranslations,
  rassChangeAccountTranslations,
} from './i18n/rass-change-account.i18n';

@Component({
  tag: 'rass-change-account',
  styleUrl: 'rass-change-account.scss',
  shadow: false,
})
export class RassChangeAccount {
  @State() assetsPath: string;
  @State() language: Language = Language.NL;
  @State() challengeData: AppModel.ChallengeData;
  unsubscribe!: Unsubscribe;

  componentWillLoad(): void {
    store.setStore(initialStore);
    this.unsubscribe = store.mapStateToProps(this, (state: RootState) => {
      const {
        config: { assetsPath, language },
        challengeData,
      } = state;
      return { assetsPath, language, challengeData };
    });
  }

  get isAltFlowChangeAccount(): boolean {
    return (
      this.challengeData &&
      this.challengeData.altFlowType === AltFlowType.CHANGE_ACCOUNT
    );
  }

  get translations(): RassChangeAccountTranslations {
    return (
      rassChangeAccountTranslations[this.language] ||
      rassChangeAccountTranslations[Language.EN]
    );
  }

  render(): void {
    return (
      <Host class="section-code-submit">
        <span
          class={`change-account-button ${this.isAltFlowChangeAccount ? '' : 'rds-display-none'}`}
        >
          <rds-button
            id="change-account"
            class="rds-padding-block-start-150"
            variant="secondary"
            onRdsClick={(): void => {
              new SignCancel()
                .doSignCancel(true)
                .then((resp) => {
                  handleContinueResponse(resp, 'change_account');
                })
                .catch((err: Error) => logd(() => console.error(err)));
            }}
          >
            {this.translations.change_account_button}
          </rds-button>
        </span>
      </Host>
    ) as void;
  }
}
